import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Upload, Loader2, Trash2, Image as ImageIcon } from "lucide-react";

export default function Media() {
  const [items, setItems] = useState([]);
  const [busy, setBusy] = useState(false);
  const backend = process.env.REACT_APP_BACKEND_URL;

  const load = () => api.get("/media").then((r) => setItems(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const upload = async (e) => {
    const files = Array.from(e.target.files || []);
    e.target.value = "";
    if (!files.length) return;
    setBusy(true);
    let ok = 0;
    for (const f of files) {
      try {
        const fd = new FormData();
        fd.append("file", f);
        await api.post("/media/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
        ok += 1;
      } catch { toast.error(`Failed: ${f.name}`); }
    }
    setBusy(false);
    if (ok) toast.success(`Uploaded ${ok} image${ok > 1 ? "s" : ""}`);
    load();
  };

  const del = async (m) => {
    try {
      await api.delete(`/media/${m.id}`);
      setItems((x) => x.filter((i) => i.id !== m.id));
    } catch { toast.error("Delete failed"); }
  };

  return (
    <div className="p-6 lg:p-8 space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="font-admin-head text-2xl sm:text-3xl font-bold text-slate-900 dark:text-white">Media</h1>
          <p className="text-slate-500 mt-1">Upload images in bulk and reuse them across products.</p>
        </div>
        <label data-testid="media-upload">
          <input type="file" accept="image/*" multiple className="hidden" onChange={upload} />
          <span className="inline-flex items-center gap-2 rounded-lg bg-blue-600 hover:bg-blue-700 text-white px-4 h-10 text-sm font-semibold cursor-pointer transition-colors">
            {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Upload className="h-4 w-4" />} Upload images
          </span>
        </label>
      </div>

      {!items.length ? (
        <div className="rounded-xl border border-dashed border-slate-300 dark:border-slate-700 py-16 text-center text-slate-400">
          <ImageIcon className="h-8 w-8 mx-auto mb-2" />
          No images yet. Upload some to build your library.
        </div>
      ) : (
        <div className="grid grid-cols-3 sm:grid-cols-5 lg:grid-cols-6 gap-3" data-testid="media-grid">
          {items.map((m) => (
            <div key={m.id} data-testid={`media-item-${m.id}`} className="group relative aspect-square rounded-xl overflow-hidden border border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-950">
              <img src={`${backend}${m.url}`} alt={m.filename} loading="lazy" className="h-full w-full object-cover" />
              <button onClick={() => del(m)} data-testid={`media-delete-${m.id}`} className="absolute top-1 right-1 h-7 w-7 rounded-full bg-black/60 text-white grid place-items-center opacity-0 group-hover:opacity-100 transition-opacity hover:bg-rose-600">
                <Trash2 className="h-3.5 w-3.5" />
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
